module.exports = __webpack_public_path__ + "img/卢卡斯.png";